/**
 * Overrides the default console methods to disable logging in production.
 * This file should be imported at the top of the main application entry point.
 */

import { isProduction } from "../config/environment";

// Store the original console methods
const originalConsole = { ...console };

if (isProduction()) {
    // In production, override console methods with empty functions
    console.log = () => {};
    console.info = () => {};
    console.warn = () => {};
    console.error = () => {
        // Optionally, you could still log errors to a monitoring service here
        // For example: Sentry.captureException(error);
    };
    console.debug = () => {};
    console.trace = () => {};
}

// You can also export a custom logger that respects the environment
export const logger = {
    log: (...args: any[]) => {
        if (!isProduction()) {
            originalConsole.log(...args);
        }
    },
    warn: (...args: any[]) => {
        if (!isProduction()) {
            originalConsole.warn(...args);
        }
    },
    error: (...args: any[]) => {
        // Always log errors, but you could add more robust reporting here
        originalConsole.error(...args);
    },
};
